import { useTranslation } from "react-i18next";
import { NewButton } from ".";
import { ButtonTypes } from "../Definitions";
import { colors, css, fonts, glyphs, icons } from "../Styles";
import { AnimalInfo } from "../Services";
import { useNavigate } from "react-router";
import { NavigationFunction as RootNavigation, Pages } from "../Navigation/root";
import { useAppSelector } from "../Store";
import { CSSProperties } from "react";

export enum Themes {
  darkmode="darkmode",
  lightmode="lightmode"
}

interface AnimalNumberDisplayProps {
  content: string;
  animal?: AnimalInfo;
  style?: CSSProperties;
  theme?: Themes
}

export default function AnimalNumberDisplay({ content, animal, style, theme = Themes.darkmode }:AnimalNumberDisplayProps) {
  const { t } = useTranslation();
  const navigator = useNavigate();
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";

  return (
    <div style={{ display: "flex", gap: "10px", ...style }}>
      {theme === Themes.lightmode ? <glyphs.Animal size="45px"/> : <img src={icons.animalsColor} style={{width: "45px", height: "45px"}} alt={""}/>}
      <div style={{display: "flex", flexDirection: "column", alignItems: "start", justifyContent: "center", gap: "2px"}}>
        <p style={{color: theme === Themes.lightmode ? colors.greyLightTertiary : colors.greyPrimary, ...fonts.fontSize4, ...fonts.header}}>{content}</p>
        {animal ? <NewButton
          content={animal ? `${t("animalPages.animal.animal", { defaultValue: "Animal" })} ${animal.animal_number}` : "-"}
          buttonType={ButtonTypes.textButton}
          overrides={{
            contentStyles: {color: theme === Themes.lightmode ? colors.greyLightTertiary : colors.greyDarkPrimary}
          }}
          onClick={() => RootNavigation({ Navigator: navigator, navigation_page: Pages.animals, navigation_tab: Pages.animal, replace: true, navArgs: { selected: animal.animal_id }, currentDomain: farm })}
        /> : <p style={{ ...css.emptyPen, color: theme === Themes.lightmode ? colors.greyLightTertiary : colors.greyPrimary, ...fonts.fontSize3, lineHeight: "1", opacity: "0.5" }}>No animal</p>}
      </div>
    </div>
  )
}